export const URL_SYSTEM_IDENTIFIER = "exact-online";
